export const EXTERNAL_LINKS = [
  { id: "crash-link", href: "https://webcrash.vermont.gov", text: "CRASH" },
  { id: "help-link", href: "http://valcour.helpdocsonline.com/home", text: "Help" },
  { id: "qa-link", href: "https://kb.valcourcloud-vt.com/", text: "Q&A" },
  { id: "sex-offender-link", href: "https://offenderwatch.com/vermont/", text: "OFFENDER WATCH" },
  { id: "vjiss-link", href: "https://vjiss.dps.state.vt.us/ojb-web-portal", text: "VJISS" },
  { id: "vows-link", href: "https://vjiss.dps.state.vt.us/vermont-vows-portal", text: "VOWS" },
  { id: "vtjpp-link", href: "https://portal.vtcourts.gov/portal", text: "VTJPP" },
]
